import { submitForm, deleteRiskProduct } from './effects'
import isNumber from 'lodash/isNumber'

export const UPDATE_PROPS = 'UPDATE_PROPS'
export const GO_TO_ADD_RISK_PRODUCT = 'GO_TO_ADD_RISK_PRODUCT'
export const SET_RISK_PRODUCT_TYPE_TO_CREATE = 'SET_RISK_PRODUCT_TYPE_TO_CREATE'
export const SUBMIT_FORM = 'SUBMIT_FORM'
export const GO_TO_INDEX = 'GO_TO_INDEX'
export const BACK = 'BACK'
export const DELETE_RISK_PRODUCT = 'DELETE_RISK_PRODUCT'
export const UPDATE_RISK_PRODUCT = 'UPDATE_RISK_PRODUCT'
export const CONFIRM_DELETE = 'CONFIRM_DELETE'
export const LOADING = 'LOADING'

export const actionCreators = (dispatch, state) => ({
  updateProps: (props) =>
    dispatch({
      type: UPDATE_PROPS,
      payload: { props }
    }),
  goToAddRiskProduct: () =>
    dispatch({
      type: GO_TO_ADD_RISK_PRODUCT
    }),
  goToIndex: () =>
    dispatch({
      type: GO_TO_INDEX
    }),
  back: () =>
    dispatch({
      type: BACK
    }),
  deleteRiskProduct: (riskProductIndex) => () =>
    dispatch({
      type: isNumber(riskProductIndex) ? DELETE_RISK_PRODUCT : GO_TO_INDEX,
      payload: { riskProductIndex }
    }),
  updateRiskProduct: (riskProductIndex) => () =>
    dispatch({
      type: UPDATE_RISK_PRODUCT,
      payload: { riskProductIndex }
    }),
  setRiskProductTypeToCreate: (riskProductType) => () =>
    dispatch({
      type: SET_RISK_PRODUCT_TYPE_TO_CREATE,
      payload: { riskProductType }
    }),

  // async actions
  submit: async (formValues) => {
    dispatch({
      type: LOADING
    })
    await submitForm(state, formValues)
    dispatch({
      type: SUBMIT_FORM
    })
  },
  confirmDelete: async () => {
    dispatch({
      type: LOADING
    })
    await deleteRiskProduct(state)
    dispatch({
      type: CONFIRM_DELETE
    })
  }
})
